import { actionTypes } from 'redux-form'
import * as actions from '../../redux/actions'
import * as t from './actionTypes'
import { createReservationProposal, initializeSections, getAvailableProperties, getAvailableObjects } from './actions'
import { getResourceAdditions } from '../booking/actions'
import { createAddition, updateAdditions, updatePreferences } from './utilities'
import analyticsUtils from '../../utilities/analyticsUtils'

// Update the reservation proposal with the updated addition preferences
const handleAdditionChange = (action, store) => {
  const field = action.meta.field.split('-')
  if (field[0] !== 'addition') {
    return
  }

  const { reservation: { criteria } } = store.getState()
  criteria.additions = updateAdditions(createAddition(field[1], action.payload, criteria), criteria.additions)

  createReservationProposal(criteria)(store.dispatch, store.getState)
}

/**
 * Update the reservation proposal with the updated preference preferences
 *
 * @param {object} action
 * @param {object} store
 */
const handlePreferenceChange = (action, store) => {
  const [field, type, id] = action.meta.field.split('-')
  if (field !== 'preference') {
    return
  }

  const { reservation: { criteria } } = store.getState()
  criteria.preferences = updatePreferences(id, type, action.payload, criteria.preferences)
  if (type === 'property') {
    getAvailableObjects(criteria, criteria.resource_id)(store.dispatch, store.getState)
  }
  getAvailableProperties(criteria)(store.dispatch, store.getState)
  createReservationProposal(criteria)(store.dispatch, store.getState)
}

// Executed when a form value changes
const handleFormChanges = (action, store) => {
  switch (action.meta.form.split('-')[0]) {
    case 'addition':
      handleAdditionChange(action, store)
      break
    case 'preferences':
      handlePreferenceChange(action, store)
      break
    default:
      break
  }
}

const eventHandler = store => next => (action) => {
  if (action.type === actionTypes.CHANGE) {
    handleFormChanges(action, store)
  }

  if (action.type === actions.POST_LOAD_CONTENT) {
    initializeSections(action.content)(store.dispatch, store.getState)
  }

  // Request the resource additions only when the addition section is triggered
  // TODO: Clean this up
  if ((action.type === t.SET_CURRENT_SECTION && action.current.name === 'addition_section') ||
    (action.type === t.SET_NEXT_SECTION && store.getState().reservation.sections.next.name === 'addition_section')) {
    const { reservation: { criteria } } = store.getState()
    getResourceAdditions(criteria.resource_id, criteria.arrival_date, criteria.duration)(store.dispatch, store.getState)
  }

  if (action.type === t.SET_CURRENT_SECTION) {
    analyticsUtils.handleSectionView(action.current)
  }
  if (action.type === t.SET_NEXT_SECTION) {
    const next = store.getState().reservation.sections.next
    if (next) {
      analyticsUtils.handleSectionView(next)
    }
  }

  return next(action)
}

export default eventHandler
